import { Component, Element, Event, EventEmitter, h, Host, Prop, Watch } from '@stencil/core'

import { CssVariables } from '../../../utils/css-variables'
import Helpers from '../../../utils/helpers'
import { CssClassMap } from '../../../utils/interfaces'
import { HorizontalAlign } from '../../../utils/types'

/**
 * Para uma descrição detalhada, consulte a [documentação do GovBR-DS](https://www.gov.br/ds/components/table?tab=designer).
 *
 * @slot default - Descrição do slot
 */
@Component({
  tag: 'br-table-header-cell',
  styleUrl: 'table-header-cell.scss',
  shadow: true,
})
export class TableHeaderCell {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrTableHeaderCellElement

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  /**
   * Define se a célula do cabeçalho possui borda vertical.
   */
  @Prop({ reflect: true }) hasVerticalBorder: boolean = false

  /**
   * Define o alinhamento horizontal do conteúdo da célula.
   * Esse alinhamento é propagado para as demais células da coluna.
   */
  @Prop({ reflect: true }) horizontalAlign: HorizontalAlign = 'left'

  private getCssClassMap(): CssClassMap {
    return {
      'br-table-header-cell': true,
      'vertical-border': this.hasVerticalBorder,
    }
  }

  @Watch('horizontalAlign')
  handleHorizontalAlignChange(newValue: HorizontalAlign) {
    this.el.style.setProperty(CssVariables.ALIGN.HORIZONTAL, newValue)
    this.brHorizontalAlignDidChange.emit(this.horizontalAlign)
  }

  /**
   * Evento disparado ao alterar o alinhamento horizontal do conteúdo da célula.
   */
  @Event() brHorizontalAlignDidChange: EventEmitter

  /**
   * Ciclo de vida do componente. Disparado sempre que o componente é conectado ao DOM.
   */
  connectedCallback() {
    this.handleHorizontalAlignChange(this.horizontalAlign)
  }

  render() {
    return (
      <Host>
        <div id={this.customId} class={this.getCssClassMap()}>
          <slot></slot>
        </div>
      </Host>
    )
  }
}
